module.exports = __webpack_public_path__ + "img/grid_item-v2_38x38.8c9b8dfd.svg";